export default __webpack_public_path__ + "static/media/kebabMenu.e2b0bce2.svg";